import { memo, useMemo } from "react";

import { useProduct } from "@shopify/hydrogen-react";

import { useSectionSettings } from "@react/sections/Root/SectionSettingsContext";
import { type ProductHeroSettings } from "@root/tablescape/state";
import {
  formatProduct,
  formatProductVariant,
} from "@root/tablescape/utilities";

import { StickyProductBarView } from "./StickyProductBar.view";

type Props = {
  addToCartButtonInView: boolean;
};

const StickyProductBarBase = ({ addToCartButtonInView }: Props) => {
  const { product, selectedVariant } = useProduct();

  const {
    productStickyBar: { desktopEnabled, mobileEnabled },
    settings: { intelligemsEnabled, theme },
  } = useSectionSettings<ProductHeroSettings>();

  const title = useMemo(() => product.title, [product]);
  const price = useMemo(() => selectedVariant.price, [selectedVariant]);
  const compareAtPrice = useMemo(
    () => selectedVariant.compareAtPrice,
    [selectedVariant]
  );
  const formattedProduct = useMemo(() => formatProduct(product), [product]);
  const formattedProductVariant = useMemo(
    () => formatProductVariant(selectedVariant),
    [selectedVariant]
  );

  return (
    <StickyProductBarView
      addToCartButtonInView={addToCartButtonInView}
      compareAtPrice={compareAtPrice}
      desktopEnabled={desktopEnabled}
      intelligemsEnabled={intelligemsEnabled}
      mobileEnabled={mobileEnabled}
      price={price}
      product={formattedProduct}
      selectedVariant={formattedProductVariant}
      theme={theme}
      title={title}
    />
  );
};

export const StickyProductBar = memo(StickyProductBarBase);
